import { registerPlugin } from '@capacitor/core';

export interface ShakePlugin {
  start(): Promise<void>;
  stop(): Promise<void>;
  addListener(
    eventName: 'shake',
    listenerFunc: () => void
  ): Promise<{ remove: () => void }>;
}

export const Shake = registerPlugin<ShakePlugin>('ShakePlugin');
